import * as constants from "../constants/cinemaUpcomingConstants";
import actionCreators from "../../../itemList/actions/tabbedMoviesActionCreators";

export default actionCreators(constants);
